export default __webpack_public_path__ + "static/media/esim_logo.cc6da7da.png";